const _ = require('./enum');

module.exports = {
  [_.ACQUIRING_FEE]: { id: _.ACQUIRING_FEE, label: 'Acquiring fee' },
  [_.ADMINISTRATIVE_ACQUIRER_FEE]: { id: _.ADMINISTRATIVE_ACQUIRER_FEE, label: 'Administrative acquirer fee' },
  [_.RISK_ASSESSMENT_FEE]: { id: _.RISK_ASSESSMENT_FEE, label: 'Risk assessment fee' },
  [_.ACCEPTANCE_FEE]: { id: _.ACCEPTANCE_FEE, label: 'Acceptance fee' },
  [_.AUTHENTICATION_FEE]: { id: _.AUTHENTICATION_FEE, label: 'Authentication fee' },
  [_.PAYOUT_FEE]: { id: _.PAYOUT_FEE, label: 'Payout fee' },
};
